import * as React from 'react';
import { withRouter, Link } from 'react-router-dom';
import Partner from '@app/api/partner/partner.actions';
import UserMgmtApi from '@app/api/user-api/user.actions';
import ExclamationCircleIcon from '@patternfly/react-icons/dist/js/icons/exclamation-circle-icon';
import { Saver } from '@app/components/Saver';
import { PasswordPolicy } from '@app/components/PasswordPolicy';
import { Spacer } from '@app/components/Spacer';
// import EthicaLogo from '@app/bgimages/ethica-logo-white.svg';
import brandImg from '@app/assets/images/generic-login.jpg';
import { textInputValidate, isValidEmail, textInputRequiredOnly, validatePassword } from '@app/lib/validator';
import { Button, Card, CardBody, Flex, FlexItem, Form, FormGroup, Title, TextInput } from '@patternfly/react-core';
// Removed userIsNotAuthenticated import - forgot password should be accessible to all users
import { Helmet } from 'react-helmet';
import { Label, Input } from 'reactstrap';
import '../../app.css';
import { Col, Row } from 'reactstrap';
import VideoBackground from '@app/components/VideoBackground';
import { connect } from 'react-redux';
import { actionCreators as sessionActionCreators } from '@app/common/session/session.reducer';

// Add custom styles
const styles = {
  forgotPasswordContainer: {
    maxWidth: '90%',
    margin: '0 auto'
  },
  ethicaButtonGreen: {
    backgroundColor: '#85ba3b',
    color: '#000000',
    border: 'none',
    borderRadius: '4px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    padding: '0.5rem 1rem',
    fontSize: '1rem',
    lineHeight: 1.5,
    cursor: 'pointer'
  },
  ethicaButtonHover: {
    backgroundColor: '#7caf33',
    color: '#000000'
  },
  formInput: {
    borderColor: '#ced4da',
    borderRadius: '4px',
    height: '42px',
    fontSize: '1rem',
    width: '100%'
  },
  confirmationCard: {
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    padding: '20px'
  },
  messageText: {
    fontSize: '1rem',
    padding: '10px',
    textAlign: 'center' as 'center'
  },
  passwordRules: {
    width: '100%',
    padding: '0 20px'
  },
  confirmationMessage: {
    borderColor: '#85ba3b',
    borderRadius: '4px',
    backgroundColor: '#f8f9fa',
    color: '#000000',
    padding: '15px',
    textAlign: 'center' as 'center',
    fontSize: '1rem',
    margin: '15px 0'
  },
  formLabel: {
    fontSize: '1rem',
    fontWeight: 500
  },
  formContainer: {
    padding: '0 15px'
  },
  title: {
    fontSize: '1.8rem',
    fontWeight: 'bold',
    marginBottom: '20px'
  },
  instructionText: {
    fontSize: '1.1rem',
    marginBottom: '20px',
    lineHeight: 1.5
  }
};

interface ForgotPasswordProps {
  history: any;
  dispatch: any;
}

interface ForgotPasswordState {
  email: string;
  message: string;
  messageType: string;
  newPassword: string;
  confirmPassword: string;
  confirmationCode: string;
  showLoginButton: boolean;
  showBackToLoginLink: boolean;
  showConfirmationCode: boolean;
  passwordErrorState: { validated: 'error' | 'default'; errorText: string } | 'default';
  confirmPasswordErrorState: { validated: 'error' | 'default'; errorText: string } | 'default';
  isLoading: boolean;
}

class ForgotPassword extends React.Component<ForgotPasswordProps, ForgotPasswordState> {
  constructor(props: ForgotPasswordProps) {
    super(props);
    this.state = {
      email: '',
      message: '',
      messageType: '',
      newPassword: '',
      confirmPassword: '',
      confirmationCode: '',
      showLoginButton: false,
      showBackToLoginLink: true,
      showConfirmationCode: false,
      passwordErrorState: 'default',
      confirmPasswordErrorState: 'default',
      isLoading: false
    };
  }



  handleChange = (key: keyof ForgotPasswordState, value: any) => {
    this.setState({ 
      [key]: value 
    } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
  };

  handleLoginClick = () => {
    this.props.history.push('/auth/login');
  }

  handleEmailKeyPress = async (event) => {
    const { email } = this.state;

    if (email && isValidEmail(email) && event.charCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      await this.sendEmail();
    }
  };

  handleSubmitEmail = async () => {
    const { email } = this.state;

    if (email && isValidEmail(email)) {
      await this.sendEmail();
    }
    else {
      this.props.dispatch(sessionActionCreators.notificationEnqueue({
        message: "A valid email address is required",
        options: {
          key: new Date().getTime() + Math.random(),
          variant: 'error',
        },
      }));
    }
  };

  sendEmail = async () => {
    const { email } = this.state;
    
    this.setState({ isLoading: true } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);

    try {
      const payload = { user_email: email };
      const result = await UserMgmtApi.requestPasswordReset(payload);

      if (result?.status === 202) {
        this.setState({
          showConfirmationCode: true,
          isLoading: false,
          message: ""
        } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
        this.props.dispatch(sessionActionCreators.notificationEnqueue({
          message: "A confirmation code has been sent to your email address.",
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'success',
          },
        }));
      } else {
        this.setState({
          showConfirmationCode: true,
          isLoading: false,
          message: ""
        } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
        this.props.dispatch(sessionActionCreators.notificationEnqueue({
          message: "A confirmation code has been sent to your email address.",
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'success',
          },
        }));
      }
    }
    catch (error: any) {
      this.setState({
        showConfirmationCode: true,
        isLoading: false,
        message: ""
      } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
      this.props.dispatch(sessionActionCreators.notificationEnqueue({
        message: "A confirmation code has been sent to your email address.",
        options: {
          key: new Date().getTime() + Math.random(),
          variant: 'success',
        },
      }));
    }
  }

  handleCodeKeyPress = async (event) => {
    if (event.charCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      await this.handleSubmitCode();
    }
  };
  
  handleSubmitCode = async () => {
    const { email, newPassword, confirmPassword, confirmationCode } = this.state;
  
    if (confirmationCode) {
      try {
        const passwordValidator = validatePassword(newPassword, confirmPassword);
  
        if (passwordValidator.isValid) {
          this.setState({ isLoading: true } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
          
          try {
            const payload = {
              user_email: email,
              new_password: newPassword,
              confirmation_code: confirmationCode
            };
            
            const result = await UserMgmtApi.confirmPasswordReset(payload);
            
            if (result?.status === 202) {
              this.setState({
                message: "Your password was reset successfully!",
                showConfirmationCode: false,
                showBackToLoginLink: false,
                showLoginButton: true,
                isLoading: false
              } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
              this.props.dispatch(sessionActionCreators.notificationEnqueue({
                message: "Your password was reset successfully!",
                options: {
                  key: new Date().getTime() + Math.random(),
                  variant: 'success',
                },
              }));
            } else {
              this.setState({ isLoading: false } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
              this.props.dispatch(sessionActionCreators.notificationEnqueue({
                message: "There was an error verifying your code. Please try again.",
                options: {
                  key: new Date().getTime() + Math.random(),
                  variant: 'error',
                },
              }));
            }
          } catch (error: any) {
            this.setState({ isLoading: false } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
            this.props.dispatch(sessionActionCreators.notificationEnqueue({
              message: "There was an error verifying your code. Please try again.",
              options: {
                key: new Date().getTime() + Math.random(),
                variant: 'error',
              },
            }));
          }
        } else {
          this.setState({ isLoading: false } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
          this.props.dispatch(sessionActionCreators.notificationEnqueue({
            message: passwordValidator.error,
            options: {
              key: new Date().getTime() + Math.random(),
              variant: 'error',
            },
          }));
        }
      } catch (error: any) {
        this.setState({ isLoading: false } as Pick<ForgotPasswordState, keyof ForgotPasswordState>);
        this.props.dispatch(sessionActionCreators.notificationEnqueue({
          message: "There was an error verifying your code. Please try again.",
          options: {
            key: new Date().getTime() + Math.random(),
            variant: 'error',
          },
        }));
      }
    } else {
      this.props.dispatch(sessionActionCreators.notificationEnqueue({
        message: "The confirmation code is required",
        options: {
          key: new Date().getTime() + Math.random(),
          variant: 'error',
        },
      }));
    }
  };

  render() {
    const { email, message, messageType, newPassword, confirmPassword, showLoginButton, showBackToLoginLink, showConfirmationCode, confirmationCode } = this.state;
    const emailIsValid = email ? isValidEmail(email) : true;
    const emailErrorState = email ? textInputValidate(email, true, emailIsValid, "Invalid email format") : { validated: 'default', errorText: "" };
    const passwordErrorState = newPassword ? textInputRequiredOnly(newPassword) : { validated: 'default', errorText: "" };
    const confirmPasswordErrorState = confirmPassword ? textInputValidate(confirmPassword, true, newPassword === confirmPassword, "Passwords must match") : { validated: 'default', errorText: "" };
    const emailFormValid = email && emailIsValid;
    const codeFormValid = newPassword && confirmPassword && (newPassword === confirmPassword);

    return (
      <React.Fragment>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <Row className="h-100 w-100 login-page overflow-x-hidden">
        <Col lg={8} md={8} sm={12} xs={12} className="bg-white">
          <div>
            <VideoBackground/>
          </div>
        </Col>
        <Col lg={4} md={4} sm={12} xs={12} className="bg-white align-content-center">
          <Row>
            <Col lg={8} md={8} sm={8} xs={8} className="m-auto">
              <div className="login-form pb-3">
                <h2 className="text-center mb-4">Forgot Password</h2>

                {showConfirmationCode ? 
                  <div>
                    <p className="text-center mb-4">Check your email for the confirmation code and enter it here</p>

                    <Form>
                      <FormGroup className="mb-3">
                        <Label for="confirmationCode">Confirmation Code</Label>
                        <Input
                          type="text"
                          id="confirmationCode"
                          value={confirmationCode}
                          onChange={(e) => this.handleChange("confirmationCode", e.target.value)}
                          onKeyPress={this.handleCodeKeyPress}
                          autoComplete='new-password'
                        />
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <Label for="newPassword">New Password</Label>
                        <Input
                          type="password"
                          id="newPassword"
                          value={newPassword}
                          onChange={(e) => this.handleChange("newPassword", e.target.value)}
                          onKeyPress={this.handleCodeKeyPress}
                          autoComplete='new-password'
                        />
                      </FormGroup>

                      <FormGroup className="mb-3">
                        <Label for="confirmPassword">Confirm Password</Label>
                        <Input
                          type="password"
                          id="confirmPassword"
                          value={confirmPassword}
                          onChange={(e) => this.handleChange("confirmPassword", e.target.value)}
                          onKeyPress={this.handleCodeKeyPress}
                          autoComplete='new-password'
                        />
                      </FormGroup>

                      <div className="mb-4">
                        <PasswordPolicy />
                      </div>
                    </Form>
                  </div>
                : showLoginButton ? 
                  <div>
                    <p className="text-center mb-4">{message}</p>
                    <div className="d-flex justify-content-center">
                      <Button 
                        color="secondary" 
                        className="ethica-button-green w-auto" 
                        isBlock
                        onClick={this.handleLoginClick}
                      >
                        Login Now
                      </Button>
                    </div>
                  </div>
                :
                  <div>
                    <p className="text-center mb-4">Enter your email address and we will send you a confirmation code to verify your identity</p>

                    <Form>
                      <FormGroup className="mb-3">
                        <Label for="email">Email</Label>
                        <Input
                          type="text"
                          id="email"
                          value={email}
                          onChange={(e) => this.handleChange("email", e.target.value)}
                          onKeyPress={this.handleEmailKeyPress}
                        />
                      </FormGroup>
                    </Form>
                  </div>
                }   

                {!showLoginButton ? 
                  <div className="d-flex justify-content-center w-100 py-4">                        
                    <Saver 
                      submitButtonText="Submit" 
                      submitButtonisDisabled={!emailFormValid || (showConfirmationCode && !codeFormValid)}
                      submit={showConfirmationCode ? this.handleSubmitCode : this.handleSubmitEmail}
                      showCancel={false}
                      showConfirmationMessage={false}
                      isLoading={this.state.isLoading}
                      message={message}
                      confirmationMessage=""
                    />
                  </div>
                : <></> }

                {showBackToLoginLink ? 
                  <div className="text-center mt-3">
                    <Link to="/auth/login" className="text-decoration-none">Back to Login</Link>
                  </div>
                : <></>}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </React.Fragment>
    );
  }
}

export default withRouter(connect(null, dispatch => ({ dispatch }))(ForgotPassword));
